import { MatPaginatorIntl } from '@angular/material/paginator';
import { Injectable } from '@angular/core';
import { TranslateService } from './translate.service';

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
  private label: string = '';

  constructor(private _translate: TranslateService) {
    super();

    this._translate?.onLangChange.subscribe((e: string) => {
      this.getAndInitTranslations();
    });
    this.getAndInitTranslations();
  }

  getAndInitTranslations() {
    this.label = this._translate.instant('label_preposition');
    this.itemsPerPageLabel = this._translate.instant('label_itemsPerPageLabel');
    this.lastPageLabel = this._translate.instant('label_lastPageLabel');
    this.nextPageLabel = this._translate.instant('label_nextPageLabel');
    this.previousPageLabel = this._translate.instant('label_previousPageLabel');
    this.firstPageLabel = this._translate.instant('label_firstPageLabel');

    this.changes.next();
  }

  getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return `0 ${this.label} ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return `${startIndex + 1} – ${endIndex} ${this.label} ${length}`;
  }
}
